(() => {
  const config = document.querySelector('.liore-collaboration-form[data-collabs-title]');

  if (!config) return;

  const matchPageIntroTypography = () => {
    const configSection = config.closest('.shopify-section');
    let pageSection = configSection?.previousElementSibling;

    while (pageSection && !pageSection.querySelector('h1')) {
      pageSection = pageSection.previousElementSibling;
    }

    pageSection?.classList.add('liore-collaboration-intro');
  };

  const localizeCollabs = () => {
    const collabs = document.querySelector('.collabs-page');

    if (!collabs) return false;

    const replacements = [
      ['.collabs-page__header h1', config.dataset.collabsTitle],
      ['.collabs-page__intro > p', config.dataset.collabsIntro],
      ['.collabs-page__cta-main', config.dataset.collabsApply],
      ['.collabs-page__cta-login-section p', config.dataset.collabsMember],
      ['.collabs-page__cta-login-link', config.dataset.collabsLogin],
    ];

    replacements.forEach(([selector, text]) => {
      const element = collabs.querySelector(selector);

      if (element && text) element.textContent = text;
    });

    collabs.querySelector('.collabs-page__partnership')?.remove();

    return true;
  };

  matchPageIntroTypography();

  if (localizeCollabs()) return;

  const observer = new MutationObserver(() => {
    if (localizeCollabs()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
